/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent")?.classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }
    console.log(cart,">>>")

    // get cart item data
    let cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    let variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    let variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    let variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    if(document.querySelector('#headerIconsCart')) document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderTitle").innerHTML = `Your Cart <strong>${cart.item_count}</strong>`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price)}</b> more for <b>FREE SHIPPING</b>`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // Skip properties that start with _
                if (key.startsWith("_")) {
                    return "";
                }

                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            /***************** savings *****************/

            // check for savings
            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    HTML += `<span>(Save ${price(savings, false)})</span>`;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}" 
                     data-plan="${sellingPlanID}"
                >
               ${sellingPlanName}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.28125 3.28125L3.86719 12.6562C3.89502 13.1979 4.28906 13.5938 4.80469 13.5938H10.1953C10.713 13.5938 11.0997 13.1979 11.1328 12.6562L11.7188 3.28125" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34375 3.28125H12.6562H2.34375Z" fill="#8F8F8F"></path><path d="M2.34375 3.28125H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M9.60938 5.15625L9.375 11.7188M5.625 3.28125V2.10938C5.62473 2.01697 5.64273 1.92541 5.67797 1.83998C5.71321 1.75455 5.76499 1.67693 5.83034 1.61159C5.89568 1.54624 5.9733 1.49446 6.05873 1.45922C6.14416 1.42398 6.23571 1.40598 6.32812 1.40625H8.67188C8.76429 1.40598 8.85584 1.42398 8.94127 1.45922C9.0267 1.49446 9.10432 1.54624 9.16966 1.61159C9.23501 1.67693 9.28679 1.75455 9.32203 1.83998C9.35727 1.92541 9.37527 2.01697 9.375 2.10938V3.28125H5.625ZM7.5 5.15625V11.7188V5.15625ZM5.39062 5.15625L5.625 11.7188L5.39062 5.15625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
            refreshMiniCartUpsell();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent")?.classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent")?.classList.add("loading");

            // add selling plan
            await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart();

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price + cartSettings.protection_upsell.variants[0].price);
    } else {
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price);
    }

     if (document.querySelector("#miniCartFooterItemcount")) {
        document.querySelector("#miniCartFooterItemcount").textContent = cart.item_count
    }
}

async function refreshMiniCartUpsell() {
setTimeout(async () => {
  try {
    const response = await fetch('/');
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newUpsell = doc.querySelector('#miniCartUpsell');
    const currentUpsell = document.querySelector('#miniCartUpsell');

    if (newUpsell && currentUpsell) {
      currentUpsell.replaceWith(newUpsell);

      new Swiper('.miniCartUpsellSlider', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
          0: {
            slidesPerView: 1.2,
          },
          768: {
            slidesPerView: 1.5,
          },
        },
        pagination: {
          el: '.miniCartUpsellPagination',
          clickable: true,
        },
      });

      atcMiniCart();
    }
  } catch (error) {
    console.error('Failed to refresh mini cart upsell:', error);
  }
}, 2000);
}


// Add Upsell function
function atcMiniCart () {
    document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
        element.addEventListener("click", async function () {
            // get variant ID from dropdown selector
            const variantID = this.closest('.miniCartUpsellItem').dataset.variant;
    
            // start loading animation
            document.querySelector("#miniCartContent")?.classList.add("loading");
    
            // create form data
            let formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                }]
            };
    
            // check for selling plan
            if (this.closest('.miniCartUpsellItem').dataset.plan) {
                let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
                formData = {
                    items: [{
                        quantity: 1,
                        id: variantID,
                        selling_plan: sellingPlanID
                    }]
                };
            }
    
            // add product upsell
            await addProduct(formData);
    
            // remove loading animation
            this.classList.remove("loading");
            refreshMiniCartUpsell();
            await openCart();
        });
    });
}
atcMiniCart()

// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart")?.addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart")?.addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout")?.addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}